import { Box, Typography, Link } from "@mui/material";

export function JoinUsCard() {
  return (
    <Box
      sx={{
        borderRadius: "24px",
        background: "#FBFAFE",
        width: "100%",
        maxWidth: "1222px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: 2,
          padding: "50px 0",
          maxWidth: "884px",
          textAlign: "center",
          alignItems: "center",
          marginX: "auto",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Open Sans, sans-serif",
            fontSize: { xs: "28px", md: "34px", lg: "40px" },
            lineHeight: { xs: "36px", md: "60px", lg: "99px" },
            letterSpacing: 0,
            fontWeight: 600,
          }}
        >
          Join us in empowering Alzheimer’s caregivers.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Open Sans, sans-serif",
            fontSize: { xs: "16px", md: "14px", lg: "18px" },
            lineHeight: { xs: "30px", md: "26px", lg: "32px" },
          }}
        >
          Every day, millions of dedicated caregivers face immense challenges
          while supporting loved ones with Alzheimer’s. No one should walk this
          path alone. With your partnership, we can ensure they never do.
          <br />
          <br />
          <strong>Let’s rewrite the story of Alzheimer’s caregiving.</strong>
          <br />
          Reach out today to discuss media or partnership opportunities:
          <br />
          Connect Now:{" "}
          <Link
            href="mailto:elevmi.info@otsuka-oph.com"
            target="_blank"
            rel="noreferrer"
            sx={{ textDecoration: "none" }}
          >
            elevmi.info@otsuka-oph.com
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
